import { memo } from "react";

import { TemplatePage } from "../../2_ksbHub/0_TemplatePage/TemplatePage";
import { useAppContext } from "../../2_ksbHub/context/appContext";

import { BszPlannerContext } from "./context/bszPlannerContext";

import useBszPlannerState from "./hooks/useBszPlannerState";

import LoadingBSZ from "./components/appFiller/LoadingBSZ";
import EmptyBSZState from "./components/appFiller/EmptyBSZState";
import BszPlannerBody from "./components/BszPlannerBody";

/**
 * =========================================================
 * ✅ BSZ PLANNER PAGE
 * =========================================================
 */
function BSZPlannerPage() {
  const { currentUser, isAnAdmin, bszPlannerLoading } = useAppContext();

  /**
   * ✅ STATE
   */
  const bszState = useBszPlannerState();

  const { projects, mySubjects, subjects } = bszState;

  /**
   * ✅ PERMISSIONS
   */
  const isBszAdmin = isAnAdmin;

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  let content;

  if (bszPlannerLoading) {
    content = <LoadingBSZ />;
  } else if (!projects) {
    content = <EmptyBSZState />;
  } else {
    content = <BszPlannerBody />;
  }

  return (
    <BszPlannerContext.Provider
      value={{
        ...bszState,
        isBszAdmin,
        currentUser,
        mySubjects,
        subjects,
      }}
    >
      <TemplatePage type="bszPlanner">{content}</TemplatePage>
    </BszPlannerContext.Provider>
  );
}

export default memo(BSZPlannerPage);
